export const CHANGE_SUMMARY_TYPE_ADDED = 'ADDED';
export const CHANGE_SUMMARY_TYPE_REMOVED = 'REMOVED';

export default {
  CHANGE_SUMMARY_TYPE_ADDED,
  CHANGE_SUMMARY_TYPE_REMOVED,
};
